import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Card } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import NotFoundRecords from 'src/components/NotFoundRecords';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import InterestBalanceTable from './InterestBalanceTable';

const useStyles = makeStyles()(() => ({
  prealoderCard: {
    minHeight: '80vh'
  }
}));

export const InterestBalanceList = ({ config }) => {
  const { classes } = useStyles();
  const dispatch = useDispatch();
  const interestBalance = useSelector(config.selectors.selectList);
  const count = useSelector(config.selectors.selectCount);
  const { page } = useSelector(config.selectors.selectQueryOptions);
  const loading = useSelector(
    isLoadingSelector([config.loadActionType.action])
  );
  const success = useSelector(successSelector([config.loadActionType.action]));

  const handleChangePage = useCallback(
    (event, value) => {
      dispatch(config.actions.load({ page: value }));
    },
    [dispatch, config.actions]
  );

  if (success && !loading && count === 0) {
    return (
      <Card className={classes.prealoderCard}>
        <NotFoundRecords
          title={config.notFoundTitle}
          description={config.notFoundDescription}
        />
      </Card>
    );
  }

  return (
    <InterestBalanceTable
      interestBalance={interestBalance}
      count={count}
      page={page}
      handleChangePage={handleChangePage}
      loading={loading}
    />
  );
};

InterestBalanceList.propTypes = {
  config: PropTypes.object.isRequired
};

export default InterestBalanceList;
